import { render, staticRenderFns } from "./disabled-input.vue?vue&type=template&id=30c2b46e&scoped=true"
import script from "./disabled-input.vue?vue&type=script&lang=js"
export * from "./disabled-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c2b46e",
  null
  
)

export default component.exports